module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.organizationSettings.bulk_price_update')) + " -  " + _vm._s(_vm.$t('static.organizationSettings.summary')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.percentage.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.percentage))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.enableRounding.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.enableRounding === true ? 'True' : 'False'))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.roundingType.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.enableRounding === true ? _vm.info.roundingType : 'None'))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('form.organizationSettings.priceType.label')) + ": "), _c('b', [_vm._v(_vm._s(_vm.info.priceType))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.run($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.confirm').toUpperCase()))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8f30bea","hasScoped":false}!./src/app/components/bulkPriceUpdatePopup/bulkPriceUpdatePopup.html
// module id = 3112
// module chunks = 1